import React, { createContext, useContext, useState } from 'react'

import { Faq, Partners as PartnersBlock } from 'components'
import { Separator } from 'shared/components'

import {
  AboutContract,
  DistributionFirstBlock,
  distributionFirstBlockId,
  Partners,
  Privilege,
  PromotionalMaterials,
} from './common'
import { scrollIntoElement } from 'shared/utils'

type Props = {
  isPartnerFormOpened: boolean
  setPartnerFormOpened: (open: boolean) => void
}

const DistributionContext = createContext<Props>({
  isPartnerFormOpened: false,
  setPartnerFormOpened: open => open,
})

export const useDistributionContext = (): Props =>
  useContext(DistributionContext)

export const Distribution = (): JSX.Element => {
  const [isPartnerFormOpened, setPartnerFormOpened] = useState(false)

  const _setPartnerFormOpened = (open: boolean) => {
    setPartnerFormOpened(open)
    scrollIntoElement(distributionFirstBlockId)
  }

  return (
    <DistributionContext.Provider
      value={{
        isPartnerFormOpened,
        setPartnerFormOpened: _setPartnerFormOpened,
      }}
    >
      {/* для seo */}
      <h1 className="hidden">Дистрибуция</h1>

      <DistributionFirstBlock />
      <Privilege />
      <Partners />
      <PromotionalMaterials />
      <Separator height={100} />
      <Faq title={'ЧЕМ МЫ МОЖЕМ ПОМОЧЬ'} />
      <Separator height={120} />
      <AboutContract />
      <Separator height={120} />
      <PartnersBlock />
      <Separator height={100} />
    </DistributionContext.Provider>
  )
}
